var _rect, _rect2, _rect3, _rect4, _ellipse, _g, _rect5, _path, _rect6, _rect7, _ellipse2, _rect8, _path2, _rect9, _rect0, _ellipse3, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCard1Mob(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 200,
    viewBox: "0 0 236 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 236,
    height: 200,
    rx: 10,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 63.5117,
    y: 45,
    width: 148.362,
    height: 31.6338,
    rx: 5.24434,
    fill: "#CCD8E2",
    fillOpacity: 0.71
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 98.0234,
    y: 56.3867,
    width: 106.155,
    height: 8.85748,
    rx: 4.42874,
    fill: "#A3BBD1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 45,
    width: 33.2535,
    height: 31.6338,
    rx: 5.24434,
    fill: "#CCD8E2",
    fillOpacity: 0.71
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.4997,
    cy: 61.3449,
    rx: 8.8454,
    ry: 8.75117,
    fill: "#A3BBD1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_562_28325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.5314 52.4651L78.2213 47.7235C77.9639 47.5766 77.6466 47.5766 77.3892 47.7235L69.079 52.4651C68.8222 52.6116 68.6641 52.8821 68.6641 53.1748V64.8305C68.6641 65.2832 69.0361 65.6503 69.4951 65.6503H72.8191H82.7913H86.1154C86.5743 65.6503 86.9464 65.2832 86.9464 64.8304V53.1748C86.9464 52.8821 86.7883 52.6116 86.5314 52.4651ZM81.9603 64.0106H73.6501V62.3709H81.9603V64.0106H81.9603ZM81.9603 60.7311H73.6501V59.0914H81.9603V60.7311H81.9603ZM81.9603 57.4517H73.6501V55.8119H81.9603V57.4517H81.9603ZM85.2844 64.0106H83.6223V54.9921C83.6223 54.5393 83.2503 54.1722 82.7913 54.1722H72.8191C72.3602 54.1722 71.9881 54.5393 71.9881 54.9921V64.0106H70.3261V53.6477L77.8052 49.3802L85.2844 53.6477V64.0106Z",
    fill: "#A3BBD1"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 63.6387,
    y: 123.367,
    width: 148.362,
    height: 31.6338,
    rx: 5.24434,
    fill: "#CCD8E2",
    fillOpacity: 0.71
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.3906 144.564V135.074H72.8295V144.564H71.3906ZM74.2683 146.462V136.735C74.2683 135.738 74.62 134.896 75.3235 134.208C76.0269 133.52 76.8742 133.176 77.8655 133.176H84.1005C85.1077 133.176 85.959 133.52 86.6544 134.208C87.3499 134.896 87.6976 135.738 87.6976 136.735V146.462H74.2683ZM89.1365 144.564V135.074H90.5753V144.564H89.1365ZM75.7072 145.038H80.2635V140.531H78.3451V139.107H80.2635V134.599H77.8655C77.2739 134.599 76.7663 134.805 76.3427 135.216C75.919 135.627 75.7072 136.134 75.7072 136.735V145.038ZM81.7024 145.038H86.2588V136.735C86.2588 136.134 86.0509 135.627 85.6353 135.216C85.2196 134.805 84.708 134.599 84.1005 134.599H81.7024V139.107H83.6209V140.531H81.7024V145.038Z",
    fill: "#A3BBD1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 98.1504,
    y: 134.754,
    width: 106.155,
    height: 8.85748,
    rx: 4.42874,
    fill: "#A3BBD1"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 123.367,
    width: 33.2535,
    height: 31.6338,
    rx: 5.24434,
    fill: "#CCD8E2",
    fillOpacity: 0.71
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.4997,
    cy: 139.712,
    rx: 8.8454,
    ry: 8.75117,
    fill: "#A3BBD1"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 63.6387,
    y: 84.2266,
    width: 148.362,
    height: 31.6338,
    rx: 5.24434,
    fill: "#CCD8E2",
    fillOpacity: 0.71
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0789 107.005C74.875 107.005 74.7042 106.937 74.5663 106.8C74.4284 106.664 74.3594 106.495 74.3594 106.293V102.972H72.9206C72.7288 102.972 72.5609 102.903 72.417 102.767C72.2731 102.631 72.2012 102.462 72.2012 102.26C72.2012 102.058 72.2691 101.889 72.405 101.753C72.5409 101.616 72.7128 101.548 72.9206 101.548H74.3594V99.1756H72.9206C72.7288 99.1756 72.5609 99.1074 72.417 98.971C72.2731 98.8346 72.2012 98.6655 72.2012 98.4639C72.2012 98.2622 72.2691 98.0932 72.405 97.9567C72.5409 97.8203 72.7128 97.7521 72.9206 97.7521H74.3594V94.739C74.3594 94.6455 74.3754 94.5549 74.4074 94.4672C74.4394 94.3795 74.4953 94.2961 74.5753 94.217L76.4937 92.319C76.6376 92.1766 76.8055 92.1055 76.9973 92.1055C77.1892 92.1055 77.3571 92.1766 77.5009 92.319L78.9158 93.7188L80.3307 92.319C80.4756 92.1766 80.6478 92.1055 80.8471 92.1055C81.0464 92.1055 81.218 92.1766 81.3619 92.319L82.7767 93.7188L84.1676 92.319C84.3126 92.1766 84.4847 92.1055 84.684 92.1055C84.8833 92.1055 85.0549 92.1766 85.1988 92.319L87.1173 94.217C87.1972 94.2961 87.2532 94.3795 87.2851 94.4672C87.3171 94.5549 87.3331 94.6455 87.3331 94.739V97.7521H88.748C88.9518 97.7521 89.1227 97.8207 89.2606 97.9579C89.3984 98.0952 89.4674 98.2652 89.4674 98.468C89.4674 98.6709 89.3984 98.8395 89.2606 98.974C89.1227 99.1084 88.9518 99.1756 88.748 99.1756H87.3331V101.548H88.748C88.9518 101.548 89.1227 101.617 89.2606 101.754C89.3984 101.891 89.4674 102.061 89.4674 102.264C89.4674 102.467 89.3984 102.636 89.2606 102.77C89.1227 102.904 88.9518 102.972 88.748 102.972H87.3331V106.293C87.3331 106.495 87.2642 106.664 87.1263 106.8C86.9884 106.937 86.8175 107.005 86.6137 107.005H75.0789ZM75.7983 97.7521H78.1964V95.0237L76.9973 93.8374L75.7983 95.0237V97.7521ZM79.6352 97.7521H82.0333V95.0237L80.8343 93.8374L79.6352 95.0237V97.7521ZM83.4962 97.7521H85.8703V95.0237L84.6712 93.8374L83.4962 95V97.7521ZM75.7983 101.548H78.1964V99.1756H75.7983V101.548ZM79.6352 101.548H82.0333V99.1756H79.6352V101.548ZM83.4962 101.548H85.8703V99.1756H83.4962V101.548ZM75.7983 105.581H78.1964V102.972H75.7983V105.581ZM79.6352 105.581H82.0333V102.972H79.6352V105.581ZM83.4962 105.581H85.8703V102.972H83.4962V105.581Z",
    fill: "#003A70"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 98.1523,
    y: 95.6133,
    width: 106.155,
    height: 8.85748,
    rx: 4.42874,
    fill: "#003A70"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 84.2266,
    width: 33.2535,
    height: 31.6338,
    rx: 5.24434,
    fill: "#CCD8E2",
    fillOpacity: 0.71
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 40.4997,
    cy: 100.571,
    rx: 8.8454,
    ry: 8.75117,
    fill: "#003A70"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5499 103.316L36.3309 101.121C36.0815 100.874 35.6786 100.874 35.4292 101.121C35.1798 101.368 35.1798 101.766 35.4292 102.013L38.1023 104.658C38.3517 104.904 38.7546 104.904 39.004 104.658L45.7698 97.9639C46.0192 97.7171 46.0192 97.3185 45.7698 97.0718C45.5204 96.825 45.1175 96.825 44.8681 97.0718L38.5499 103.316Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_562_28325"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.2823,
    height: 18.037,
    fill: "white",
    transform: "translate(68.6621 47.6133)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1Mob);
export default __webpack_public_path__ + "static/media/card1_mob.3c1c9ebf58020dc4bc8a8420685c50c4.svg";
export { ForwardRef as ReactComponent };